const ApolloClient = require("apollo-boost").default;
const client = new ApolloClient({
  uri: "https://dev-clover-server.azurewebsites.net/graphql"
});

export default client;
